import { createRoot } from 'react-dom/client'
import './index.css'
import 'animate.css';
import App from './App'

createRoot(document.getElementById('root')).render(
  <App />
)
